
import React from 'react';

const ToolbarSeparator = (props) => {

    return (
        <div style={{width: 16, height: 16}} />
    );
}

export default ToolbarSeparator;
